import PropTypes from "prop-types";

export const PDPContentPropType = PropTypes.shape({
  membership: PropTypes.shape({
    hed: PropTypes.string,
    dek: PropTypes.string,
    membershipCta: PropTypes.string,
    reserveCta: PropTypes.string,
  }),
  noIntent: PropTypes.shape({
    membershipCta: PropTypes.shape({
      hed: PropTypes.string,
      dek: PropTypes.string,
    }),
    reserveCta: PropTypes.shape({
      hed: PropTypes.string,
      dek: PropTypes.string,
    }),
  }),
});
